import { defineStore } from "pinia";
import { ref } from "vue";
import { Cruise } from "@/interfaces/cruise";

export const useCruiseStore = defineStore('cruises', () => {
    const cruise = ref<Cruise>();

    const assignCurrentCruise = (currentCruise: Cruise) => {
        cruise.value = currentCruise;
    }

    return { cruise, assignCurrentCruise }
});